module.exports = "<h3>{{title}}</h3>\n<p>{{content}}</p>\n<div class=\"btns\" *ngIf=\"!hideButtons\">\n  <button mat-button mat-dialog-close>No</button>\n  <button mat-button [mat-dialog-close]=\"true\">Yes</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialog/confirm-dialog.component.html
// module id = ./src/app/shared/dialog/confirm-dialog.component.html
// module chunks = main